export default {
    "getCustomer": "4a72b73b7b2e4bad4aaab82813710a7adf59349d8a91bf6ceb5a1cfcfac71d58",
    "affiliateClickEvent": "a4ed34bc133f61b69bec256ff945fcabf11585df9591e5b9a8da117e713ebf71"
};
